import { create } from "zustand";
import { persist } from "zustand/middleware";

export type Currency = "USD" | "JPY" | "EUR" | "GBP";

export const SUPPORTED_CURRENCIES: { code: Currency; label: string }[] = [
  { code: "USD", label: "USD $" },
  { code: "JPY", label: "JPY ¥" },
  { code: "EUR", label: "EUR €" },
  { code: "GBP", label: "GBP £" },
];

interface CurrencyStore {
  currency: Currency;
  enabledCurrencies: Currency[];
  aiEnabled: boolean;
  umamiWebsiteId: string;
  siteMode: string;
  maintenanceMessage: string;
  setCurrency: (c: Currency) => void;
  setEnabledCurrencies: (currencies: Currency[]) => void;
  setAiEnabled: (enabled: boolean) => void;
  setUmamiWebsiteId: (id: string) => void;
  setSiteMode: (mode: string) => void;
  setMaintenanceMessage: (msg: string) => void;
}

export const useCurrencyStore = create<CurrencyStore>()(
  persist(
    (set) => ({
      currency: "USD",
      enabledCurrencies: ["USD", "JPY"],
      aiEnabled: true,
      umamiWebsiteId: "",
      siteMode: "normal",
      maintenanceMessage: "We are currently performing maintenance. Please check back later.",
      setCurrency: (currency) => set({ currency }),
      setEnabledCurrencies: (enabledCurrencies) => set({ enabledCurrencies }),
      setAiEnabled: (aiEnabled) => set({ aiEnabled }),
      setUmamiWebsiteId: (umamiWebsiteId) => set({ umamiWebsiteId }),
      setSiteMode: (siteMode) => set({ siteMode }),
      setMaintenanceMessage: (maintenanceMessage) => set({ maintenanceMessage }),
    }),
    { name: "chlolo-currency" }
  )
);
